import { isNumber } from "lodash";

function descendingComparator(a, b, orderBy) {
    if(orderBy.toLowerCase().includes("date")){
        const orderDate = orderBy+"Raw";
        const aDate = a[orderDate] ? a[orderDate] : null;
        const bDate = b[orderDate] ? b[orderDate] : null;
        return new Date(aDate) - new Date(bDate);
    }
    else if(isNumber(a[orderBy]) && isNumber(b[orderBy])){
        return a[orderBy] - b[orderBy];
    }
    else {
        const aString = a[orderBy] ? a[orderBy].toString().toLowerCase() : "";
        const bString = b[orderBy] ? b[orderBy].toString().toLowerCase() : "";
        return aString.localeCompare(bString);
    }
}

export function getComparator(order, orderBy) {
    return order === "desc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export function getVisibleRows(rows, order, orderBy, page, rowsPerPage) {
    return stableSort(rows, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
}
